import React, { Component } from "react"
import MetaTags from 'react-meta-tags';

import { format } from 'date-fns';
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardHeader,
  CardTitle,
  FormGroup,
  Label,
  Button,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Breadcrumb,
  BreadcrumbItem,
 

} from "reactstrap";
import CreatableSelect from 'react-select/creatable';
import Select from "react-select";
import axios from 'axios';
import  { Redirect } from 'react-router-dom';
// import $ from "jquery";
import {components} from 'react-select'
import Flatpickr from "react-flatpickr";
import { French } from "flatpickr/dist/l10n/fr.js";
import ReactSelect from 'react-select';
import makeAnimated from 'react-select/animated';
//import BootstrapSelect from "bootstrap-select"
import url from "../../common/api"
import {getLanguageList} from "../../services/langueService.js"
import {getThematiqueList} from "../../services/thematiqueService.js"
import {getTypeEvenementList} from "../../services/typeEvenementService.js"
import {getTypeSystemeIrrigueList} from "../../services/systemeIrrigueService.js"
import {addMotCle,getMotCleList} from "../../services/motCleService.js"
import {getPaysList} from "../../services/paysService.js"
import {getQueries} from "../../queries/getQueries.js"
import {postQueries} from "../../queries/postQueries.js"
import ModalMessage from "../pages/messages/ModalMessage"
import profile from './../../store/auth/profile/reducer';
import { WindowScrollController } from "@fullcalendar/react";


const Menu = props => {
  const optionSelectedLength = props.getValue().length || 0;
  return (
    <components.Menu {...props}>
      {optionSelectedLength < 5 ? (
        props.children
      ) : (
        <div style={{ margin: 15 }}>Vous avez atteint le nombre maximum de mot-clés</div>
      )}
    </components.Menu>
  );
};

class AjoutEvenement extends Component {

  constructor(props) {
    super(props)
    this.state = {
      ok:"",
      thematique:[],
      irrigue:[],
      unite:[],
      localisation:[],
      langue:[],
      public_id:0,
      profile:[],
      profile_id:[],
      type_evenement:[],
      unites_attributes:[],
      motCles_attributes:[],
      systeme_attributes:[],
      langues_attributes:[],
      profiles_attributes:[],
      thematiques_attributes:[],
      localisation_attributes:[],
      angues_attributes:[],
      heureDebut:"",
      message:"Veuillez renseigner les champs obligatoires!!",
      heureFin:"",
      dateDebut:"",
      dateFin:"",defaultDate:new Date(),
      show:false,
      success:true, 
      message:"Evènement ajouté avec succès !",
      titre:"Message ajout d'évènement", 
      boutton:"OK",

    }

    this.handleChangeUnite.bind(this);
    this.handleChangeThematique.bind(this);
    this.handleChangeSysteme.bind(this);
    this.handleChangeMotCle.bind(this);
    this.handleChangeThematique.bind(this);
    this.handleHeureDebut.bind(this);
    this.handleHeureFin.bind(this);
    this.handleChangeProfile.bind(this);
    this.handleChangeAcces.bind(this);
    this.handleValideTypeEvenement.bind(this);
    this.handleDateInterval.bind(this);
    this.handleChangeLangue.bind(this);
    this.handleChangeLocalisation.bind(this);
  }

  componentDidMount() {
  
    $('textarea').keyup(function() {    
      var characterCount = $(this).val().length,
          current_count = $('#current_count'),
          maximum_count = $('#maximum_count'),
          count = $('#count');    
          current_count.text(characterCount);        
    });

    $("#chargement").css("display","none")
    $("#echecSave").css("display","none")
    $("#profile").css("display","none")
   
   var date1=new Date();
    
   //date debut et fin par defaut
   this.setState({dateDebut:date1})
   const date2=new Date(date1.setDate(date1.getDate()+1))
   this.setState({dateFin:date2})
    
   var profile=JSON.parse(sessionStorage.getItem("authAshia"))?.profile
   

   getLanguageList().then(e=>this.setState({langue:e}))
   getPaysList().then(e=>this.setState({localisation:e}))
   getThematiqueList().then(e=>this.setState({thematique:e}))
   //getUniteAdministrativeList().then(e=>this.setState({unite:e}))
   getTypeEvenementList().then(e=>this.setState({type_evenement:e}))
   getMotCleList().then(e=>this.setState({motcle:e}))
   getTypeSystemeIrrigueList().then(e=>this.setState({irrigue:e}))

   
   getQueries("profiles").then(e=>{
     const data=e
     try{
       this.setState({public_id:data.filter(x => (x.libelle).toLowerCase() === ("Public").toLowerCase())[0].id})

       
      }catch(error){
 
      }

      data.filter(x => (x.libelle).toLowerCase() != ("Public").toLowerCase()).map((element,idx) =>{
       this.setState({profile:[...this.state.profile,{value:element.id,label:element.libelle}]})
     })

   })




 }


 handleChangeThematique = (e) => {
  this.setState({thematiques_attributes:[]})
  try{
    e.map((element,idx) =>{
      this.setState({thematiques_attributes:[...this.state.thematiques_attributes,{"thematique_id":element.value}]})
    })
  }catch(error){

  }
 
}
handleChangeMotCle=(e)=>{
  this.setState({motCles_attributes:[]})
  try{
    e.map((element,idx) =>{
      this.setState({motCles_attributes:[...this.state.motCles_attributes,{"mot_cle_id":element.value}]})
    })
  }catch(error){
    
  }
}
handleChangeUnite = (e) => {
  this.setState({unites_attributes:[]})
  try{
    e.map((element,idx) =>{
      this.setState({unites_attributes:[...this.state.unites_attributes,{"unite_administrative_id":element.value}]})
    })
  }catch(error){
    
  }

}
handleChangeSysteme = (e) => {
  this.setState({systeme_attributes:[]})
  try{
    e.map((element,idx) =>{
      this.setState({systeme_attributes:[...this.state.systeme_attributes,{"type_systeme_irrigue_id":element.value}]})
    })
  }catch(error){

  }

}

handleChangeLocalisation = (e) => {
  $("#champ-unite-administrative").hide()
  var data=[]
  this.setState({localisation_attributes:data,unite:data})
  var localisation=[]
  var unite=[]
  try{

      e.map((element,idx) =>{
        
        
        element.unite_administratives.map((el)=>{
          unite=[...unite,{value:el.id,label:el.libelle}]
          this.setState({unite:unite})
        })
        localisation=[...localisation,{"pay_id":element.value}]

        this.setState({localisation_attributes:localisation})
        
      })
  
  } catch(e){
    this.setState({localisation_attributes:data,unite:data,unites_attributes:data})
  }
}

handleChangeLangue = (e) => {
  var data=[]
  this.setState({langues_attributes:data})
  try{
      e.map((element,idx) =>{
        this.setState({langues_attributes:[...this.state.langues_attributes,{"langue_id":element.value}]})
      })
    }catch(error){
      this.setState({langues_attributes:data})
    }   
}

handleChangeAcces = () => {
  console.log("le select",$("#acces option:selected").val())
 if($("#acces option:selected").val()=="Privée"){
    $("#profile").css("display","block")
 }else{
  $("#profile").css("display","none")
  

 }
}
handleChangeProfile = (e) => {
  var data=[]
  this.setState({profiles_attributes:[]})
  console.log("===>>",e)
  try{
    e.map((element,idx) =>{
      this.setState({profiles_attributes:[...this.state.profiles_attributes.filter(x => x.profile_id != this.state.public_id),{"profile_id":element.value}]})
      console.log("===>>profile dans evenement",element)
    })

  }catch(e){
    this.setState({profiles_attributes:data})
  }


}

handleDateInterval= (date)=> {
  if(date.length==2){
    var date1 = new Date(date[1]);
    // date1.setDate(date1.getDate() - 1)
    // Date2.setDate(Date2.getDate()+1);
    console.log("Date kk >>",date1)

    this.setState({dateDebut:date[0],dateFin:date1})
    
    console.log("Date de debut >>",date[0])
    console.log("Date de fin >>",date[1])

    // console.log("Date hh >>",date1.setDate(date[1].getDate()+1))
    // console.log("Date hh >>",Date2)
    $("#valideDate").hide()
    $("#date").removeClass("is-invalid")
    $("#echecSauv").hide()   
  }else{
    $("#valideDate").show()
    $("#date").addClass("is-invalid")
  }
}

handleHeureDebut= (date)=> {
 
  const NewDate= format(date[0],'HH:mm');
  this.setState({heureDebut:NewDate})
}
handleHeureFin= (date)=> {
  const NewDate= format(date[0],'HH:mm');
  this.setState({heureFin:NewDate})
}

handleValideTypeEvenement=(e)=>{
  if(e.target.value!=0){
    $("#valideRessource").css("display","none")
    $("#type_evenement_id").removeClass("is-invalid")
    $("#echecSave").css("display","none")
  }else{
    $("#valideRessource").css("display","block")
    $("#type_evenement_id").addClass("is-invalid")
  }
}
handleErrorLibelle=(e)=>{
  if(e.target.value!=0){
    $("#valideLibelle").hide()
    $("#libelle").removeClass("is-invalid")
    $("#echecSauv").hide()
  }else{
    $("#valideLibelle").show()
    $("#libelle").addClass("is-invalid")
  }
}

handleErrorOrganisateur=(e)=>{
  if(e.target.value!=0){
    $("#valideOrganisateur").hide()
    $("#organisateur").removeClass("is-invalid")
    $("#echecSauv").hide()
  }else{
    $("#valideOrganisateur").show()
    $("#organisateur").addClass("is-invalid")
  }
}

handleErrorLieu=(e)=>{
  if(e.target.value!=0){
    $("#valideLieu").hide()
    $("#lieu").removeClass("is-invalid")
    $("#echecSauv").hide()
  }else{
    $("#valideLieu").show()
    $("#lieu").addClass("is-invalid")
  }
}

handleErrorObjectif=(e)=>{
  if(e.target.value!=0){
    $("#valideObjectif").hide()
    $("#objectif").removeClass("is-invalid")
    $("#echecSauv").hide()
  }else{
    $("#valideObjectif").show()
    $("#objectif").addClass("is-invalid")
  }
}

// handleErrorDate=(e)=>{
//   if(e.target.value!=0){
//     $("#valideDate").hide()
//     $("#date").removeClass("is-invalid")
//     $("#echecSauv").hide()
//   }else{
//     $("#valideDate").show()
//     $("#date").addClass("is-invalid")
//   }
// }
    
handleSendEvent=()=>{
  $("#initial").css("display","none")
   $("#chargement").css("display","block")
  var date=new Date();
  var profile=[...this.state.profiles_attributes,{"profile_id":this.state.public_id}]
  
  const NewDate= format(date,'dd/MM/yyyy');
  var data= {
    "libelle": $("#libelle").val(),
    "date_debut": this.state.dateDebut,
    "date_fin":this.state.dateFin,
    "heure_debut": this.state.heureDebut,
    "heure_fin":this.state.heureFin,
    "user_id":JSON.parse(sessionStorage.getItem("authAshia")).id ,
    "description": $("#description").val(),
    "url": $("#url").val(),
    "organisateur":$("#organisateur").val(),
    "lieu":$("#lieu").val(),
    "objectif":$("#objectif").val(),
    "cible":$("#cible").val(),
    "type_evenement_id":$("#type_evenement_id option:selected").val(),
    "evenement_profiles_attributes":_.uniqBy(profile, 'profile_id'),
    "evenement_langues_attributes":this.state.langues_attributes,
    "evenement_mot_cles_attributes":this.state.motCles_attributes,
    "evenement_pays_attributes":this.state.localisation_attributes,
    "evenement_thematiques_attributes":this.state.thematiques_attributes,
    "evenement_unite_administratives_attributes":this.state.unites_attributes,
    "evenement_systeme_irrigues_attributes":this.state.systeme_attributes

  }
  console.log("data to send",$("#type_evenement_id option:selected").val())

  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json','Accept': 'application/json' },
    body: JSON.stringify(data)
};
  
if($("#type_evenement_id option:selected").val()=="0"){
  $("#type_evenement_id").addClass("is-invalid")
  this.setState({message:"Veuillez selectionner le type d'évènement !"})
  this.setState({show:true,success:false});
  $("#echecSave").css("display","block")
  $("#chargement").css("display","none")
  $("#initial").css("display","block")
  // window.location.reload(true);
}else{

  fetch(url+'evenements', requestOptions)
  .then(response => response.json()
 )
 .then(data =>{
   $("#chargement").css("display","none")
   this.setState({message:"L'évènement a été ajouté avec succès !"})
   this.setState({show:true,success:true});

},
(error) => {
 if (error) {
   $("#echecSave").css("display","block")
   this.setState({message:"Echec de la Sauvegarde.Veuillez reéssayer !"})
   this.setState({show:true,success:false});
   $("#initial").css("display","block")
   $("#chargement").css("display","none")
   
 }
} )



}


}

handleRetour=()=>{
  this.setState({ok: <Redirect to='/liste-calendar'  />});
}

handleAnnuler=()=>{
  this.setState({ok: <Redirect to='/liste-calendar'  />});
}

handleValidate=()=>{
  this.setState({show:false})
  if(this.state.success){
    this.setState({ok: <Redirect to='/liste-calendar'  />});
  }
  
}
handleCreate = inputValue => {
  console.log(inputValue);
};

getNewOptionData = inputValue => {
  this.setState({
    inputValue: [inputValue]
  });
};

 render() {

  const { pick } = this.state
  const animatedComponents = makeAnimated();
  const isValidNewOption = (inputValue, selectValue) => inputValue.length > 0 && selectValue.length < 5;
  
  return (
          <React.Fragment>
            <div className="page-content">   {this.state.ok}

            <ModalMessage
                show={this.state.show}
                success={this.state.success}
                boutton={this.state.boutton}
                handleValidate={this.handleValidate}
                message={this.state.message}
                titre={this.state.titre}
                onCloseClick={() => this.setState({ show: false })}
             />

            <MetaTags>
                <title>Créer un évenement</title>
            </MetaTags>
            <Container fluid={true}>
                <Row>
                  <Col md="8">
                      <div className="page-title-box d-flex align-items-center justify-content-between">
                      <h4 className="mb-0 font-size-18">Nouvel événement</h4>
                      </div>
                  </Col>
                </Row>
     
                <hr/>

                <Card style={{borderRadius:"25px",borderColor:"#AAD29A",borderWidth:"5px"}}>
                  <CardBody>
                  <h4 className="text-center mt-2">Description de l'évenement</h4>
                  <hr/>
                  <Row className="mt-4"> 
                    <Col md="12">
                      <label>Libellé</label>
                      <Input
                        onChange={this.handleErrorLibelle}
                        className="form-control is-invalid"
                        type="text"
                        id="libelle"
                        placeholder="Libellé"
                      />
                      <div style={{float:"center"}} id="valideLibelle" class="invalid-feedback">
                        Svp veuillez donner un titre à cet évènement.
                      </div>
                    </Col>
                  </Row>

                  <Row className="mt-4">
                    <Col md="12">
                      <label>Organisateur(s)</label> 
                      <Input
                        onChange={this.handleErrorOrganisateur}
                        className="form-control is-invalid"
                        type="text"
                        id="organisateur"
                        placeholder="Organisateur(s)"
                      />
                      <div style={{float:"center"}} id="valideOrganisateur" class="invalid-feedback">
                        Svp veuillez définir les organisateurs.
                      </div>
                    </Col>
                  </Row>

                  <Row className="mt-4">
                    <Col md="6">
                      <label>Types D'évenement</label>
                      <select onChange={this.handleValideTypeEvenement} className="form-select is-invalid" aria-label="Default select example" id="type_evenement_id">
                        <option value="0" selected>Choisir le type d'évenement</option>

                        {
                          this.state.type_evenement.map((element,idx) =>(
                            <option value={element.value}>{element.label}</option>
                          ))
                        }

                      </select>
                      <div style={{float:"center"}} id="valideRessource" class="invalid-feedback">
                        Svp veuillez Choisir le type d'evenement.
                      </div>
                    </Col>
                    <Col md="6">
                      <label>Lieu</label>
                      <Input
                        onChange={this.handleErrorLieu}
                        className="form-control is-invalid"
                        type="text"
                        id="lieu"
                        placeholder="Lieu"
                      /> 
                      <div style={{float:"center"}} id="valideLieu" class="invalid-feedback">
                        Svp veuillez définir le lieu.
                      </div>
                    </Col>
                  </Row>

                  <Row className="mt-4">
                    <Col md="6">
                      <label>Objectif(s)</label>
                      <Input
                        onChange={this.handleErrorObjectif}
                        className="form-control is-invalid"
                        type="text"
                        id="objectif"
                        placeholder="Objectif(s)"
                      />
                      <div style={{float:"center"}} id="valideObjectif" class="invalid-feedback">
                        Svp veuillez définir l'objectif de ce évènement.
                      </div>
                    </Col>
                    <Col md="6">
                      <label>Cible</label>
                      <Input
                        className="form-control"
                        type="text"
                        id="cible"
                        placeholder="Cible"
                      /> 
                    </Col>
                  </Row>

                  <Row className="mt-4">

                    <Col className="col-4">
                      <label>Dates de début et de Fin</label>
                      <div className="docs-datepicker">
                        <InputGroup>
                          <Flatpickr
                            id="date"
                            value={pick}
                            className="form-control d-block "
                            placeholder="Choisissez les dates de début et de fin"
                            options={{
                              minDate: "today",
                              locale:French,
                              mode: "range",
                              altInput: true,
                              // altFormat: "F j, Y",
                              altFormat: "d/M/Y"
                            }}
                            onChange={this.handleDateInterval}
                          />
                          <div className="input-group-append">
                            <button
                              type="button"
                              className="btn btn-outline-secondary docs-datepicker-trigger"
                              disabled
                            >
                              <i
                                className="fa fa-calendar"
                                aria-hidden="true"
                              />
                            </button>
                          </div>
                        </InputGroup>
                        
                        <div className="docs-datepicker-container" />
                      </div>
                      
                    </Col> 

                    <Col md="4">
                      <label>Heure de début de l'évènement</label>
                      <div className="docs-datepicker">
                        <InputGroup>
                          <Flatpickr
                            className="form-control d-block"
                            placeholder="heure de debut de l'évenement"
                            options={{
                              locale:French,
                              enableTime: true,
                              noCalendar: true,
                              dateFormat: "H:i",
                              //defaultDate: "13:45"
                            }}
                            onChange={this.handleHeureDebut}

                          />
                          <div className="input-group-append">
                            <button
                              type="button"
                              className="btn btn-outline-secondary docs-datepicker-trigger"
                              disabled
                            >
                              <i
                                className="fa fa-clock"
                                aria-hidden="true"
                              />
                            </button>
                          </div>
                        </InputGroup>
                        <div className="docs-datepicker-container" />
                      </div>
                    </Col>

                    <Col md="4">
                      <label>Heure de fin de l'évènement</label>
                      <div className="docs-datepicker">
                        <InputGroup>
                          <Flatpickr
                            className="form-control d-block"
                            placeholder="heure de fin de l'évenement"
                            options={{
                              locale:French,
                              enableTime: true,
                              noCalendar: true,
                              dateFormat: "H:i",
                              //defaultDate: "13:45"
                            }}
                            onChange={this.handleHeureFin}

                          />
                          <div className="input-group-append">
                            <button
                              type="button"
                              className="btn btn-outline-secondary docs-datepicker-trigger"
                              disabled
                            >
                              <i
                                className="fa fa-clock"
                                aria-hidden="true"
                              />
                            </button>
                          </div>
                        </InputGroup>
                        <div className="docs-datepicker-container" />
                      </div>
                    </Col>
                  </Row>

                  <Row className="mt-4"> 
                    <Col md="12" > 
                      <label>Description  </label> <i class='bx bx-border bx-xs'> <small id="current_count">0</small> <small id="maximum_count">/ 1000</small> </i> 
                      <textarea rows="6" className="form-control" maxlength="1000" autofocus id="description" placeholder="Description" />
                    </Col>
                  </Row>

                  </CardBody>
                </Card>

                <Card style={{borderRadius:"25px",borderColor:"#AAD29A",borderWidth:"5px"}}>
                  <CardBody>
                  <h4 className="text-center mt-2">Catégorisation de l'évènement</h4>
                  <hr/>
                  <Row className="mt-4"> 
                    <Col md="6">
                      <label>Langue(s)</label>
                      <ReactSelect
                        closeMenuOnSelect={false}
                        components={animatedComponents}
                        isMulti
                        onChange={this.handleChangeLangue}
                        options={this.state.langue}
                        placeholder="Choisir la/les langue(s)"
                      />
                    </Col>  
                    <Col md="6">
                      <label>Type(s) de système(s) d'irrigation</label>
                      <ReactSelect
                        closeMenuOnSelect={false}
                        components={animatedComponents}
                        isMulti

                         onChange={this.handleChangeSysteme}
                         options={this.state.irrigue}

                        placeholder="Choisir le/les type(s) de système d'irrigation"
                      />
                    </Col>
                  </Row>

                  <Row className="mt-4"> 
                    <Col md="6">

                      <label>Pays(s)</label>
                      <div
                        data-toggle="tooltip" 
                        data-placement="top" 
                        data-html="true"
                        title="Choisir Autres si Région ou pays en dehors des six pays du Sahel listés et mieux préciser dans Unité administrative"
                      >
                        <ReactSelect
                          closeMenuOnSelect={false}
                          components={animatedComponents}
                          isMulti
                          onChange={this.handleChangeLocalisation}
                          options={this.state.localisation}
                          placeholder="Choisir la/les Pays(s)"
                        />
                      </div>
                    </Col>
                    {
                      this.state.unite.length?
                    <Col md="6" >
                      <label>Unité(s) administrative</label>
                      <div
                        data-toggle="tooltip" 
                        data-placement="top"
                        data-html="true"
                        title="Région particulière, ville ou division administrative du pays"
                      >
                        <ReactSelect
                          closeMenuOnSelect={false}
                          components={animatedComponents}
                          isMulti
                          onChange={this.handleChangeUnite}
                          options={_.uniqBy(this.state.unite, 'label')}
                          placeholder="Choisir l'unité administrative"
                        />
                      </div>
                    </Col>:null
                    }
                  </Row>


                  <Row className="mt-4"> 
                    <Col md="6">
                      <label>Thématique(s)</label>
                      <ReactSelect
                        closeMenuOnSelect={false}
                        components={animatedComponents}
                        isMulti

                         onChange={this.handleChangeThematique}
                         options={this.state.thematique}

                        placeholder="Choisir la/les thématique(s)"
                      />
                    </Col>
                    
                    <Col md="6">
                      <label>Mot(s) clé</label>
                      {/* <ReactSelect
                        closeMenuOnSelect={false}
                        components={{Menu}}
                        isMulti
                        onChange={this.handleChangeMotCle}
                        isValidNewOption={isValidNewOption}
                        options={this.state.motcle}
                        placeholder="Choisir le/les mot(s) clé"

                      /> */}
                      <CreatableSelect
                        closeMenuOnSelect={false}
                        components={{Menu}}
                        isMulti
                        onChange={this.handleChangeMotCle}
                        isValidNewOption={isValidNewOption}
                        options={this.state.motcle}
                        placeholder="Choisir la/les mot(s) clé(s)"
                      />
                    </Col>
                  </Row>
                  </CardBody>
                </Card>

                <Card style={{borderRadius:"25px",borderColor:"#AAD29A",borderWidth:"5px"}}>
                  <CardBody>
                  <h4 className="text-center mt-2">Média</h4>
                  <hr/>
                  <Row className="mt-4"> 
                    <Col md="12"> 
                      <label>Url</label>
                      <div className="input-group">
                        <Input
                          type="text"
                          className="form-control"
                          id="url"
                          placeholder="URL"
                        />
                        <div className="input-group-prepend  d-inline-block">
                          <span
                            className="input-group-text h-20"
                            id="validationTooltipUsernamePrepend"
                          >
                            <i className="bx bx-link"></i>
                          </span>
                        </div>
                      </div> 
                    </Col>
                  </Row>

                  </CardBody>
                </Card>

                <hr></hr>


                <Row className="mt-4"> 
                  <Col md="6">
                    <label>Type d'accès</label>
                    <select className="form-select" onClick={this.handleChangeAcces} aria-label="Default select example" id="acces">
                      <option selected>{JSON.parse(sessionStorage.getItem("authAshia"))?.profile?.libelle}</option>
                      <option value="Public">Public</option>
                      <option value="Privée">Privé</option>
                    </select>
                  </Col>  
                  <Col md="6" >
                    <div id="profile">
                      <label>Profil(s)</label>
                      <ReactSelect
                        closeMenuOnSelect={false}
                        components={animatedComponents}
                        isMulti
                        options={this.state.profile}
                        placeholder="Choisir le/les profils(s)"
                        onChange={this.handleChangeProfile} 
                        aria-label="Default select example" 
                        id="profile_id"
                      />
                    </div>
                  </Col>
                </Row>
     


                <Row className="justify-content-start mt-5 mb-5">
                  <Col md="6">
                    <Button style={{backgroundColor:"#aad29a", borderColor:"#aad29a",float:"right",borderRadius:"10px"}} id="initial" color="success"

                     onClick={this.handleSendEvent}
                    >
                      Créer l'évenement
                    </Button>
                    
                    <Button style={{float:"right",borderRadius:"10px"}} id="chargement" color="info" className="b-lg" type="button" disabled>
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"> </span>
                      Ajout de l'évènement...
                    </Button>

                  </Col>

                  <Col md="6">
                    <Button  style={{backgroundColor:"#6A7172",float:"left",borderRadius:"10px"}}  color="secondary" onClick={this.handleAnnuler}>
                      Annuler
                    </Button>
                  </Col>
                </Row>

                <Row className="justify-content-start mt-5 mb-5">
                  <Col md="3"></Col>
                  <Col md="6">
                  <div style={{textAlign:"center"}}>
                    <div id="echecSave" className="alert alert-danger mt-2" role="alert">
                        {this.state.message}
                    </div>
                  </div>
                  </Col>
                  <Col md="3"></Col>
                </Row> 
              </Container>
              </div>
             
          </React.Fragment>
        )}

  }
  export default AjoutEvenement